/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ server: NonNullable<unknown> }} Audit_Details_Mcp_Server_Deleted_DescInputs */



/**
* | output |
* | --- |
* | "The MCP server \"{server}\" was removed and its tools are no longer available." |
*
* @param {Audit_Details_Mcp_Server_Deleted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_mcp_server_deleted_desc = /** @type {((inputs: Audit_Details_Mcp_Server_Deleted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Mcp_Server_Deleted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der MCP-Server "${i?.server}" wurde entfernt, seine Werkzeuge stehen nicht mehr zur Verfügung.`)
	return /** @type {LocalizedString} */ (`The MCP server "${i?.server}" was removed and its tools are no longer available.`)
});